module.exports = __webpack_public_path__ + "media/educators/tabs-281b014a.png";